import { type FC } from 'react';

import {
  type PaidSpecContractType,
  type SpecContractStatusType,
  type SpecContractType,
} from '@/common/types/contract';
import { AboutSpecContract } from '@/components/Contract/AboutSpecContract/AboutSpecContract';

import { SpecContractWrapper } from '../common/SpecContractWrapper/SpecContractWrapper';

interface CustomContractModal {
  status: SpecContractStatusType;
  kind?: SpecContractType | PaidSpecContractType;
}

const CustomContractModal: FC<CustomContractModal> = () => {
  const kind = 'Custom';

  return (
    <SpecContractWrapper kind={kind}>
      <AboutSpecContract kind={kind} />
    </SpecContractWrapper>
  );
};

export { CustomContractModal };
